import React from 'react';
import get from 'lodash/get';

export const NOTIFICATION_TYPE = {
  POST: 'post',
  INVITE: 'invite',
  JOIN_REQUEST: 'joinRequest',
};

export function getNotificationType(subject) {
  if ('inviter' in subject) return NOTIFICATION_TYPE.INVITE;
  if ('approvalStatus' in subject) return NOTIFICATION_TYPE.POST;
  return NOTIFICATION_TYPE.JOIN_REQUEST;
}

export function getNotificationDetailsByType(type, subject) {
  switch (type) {
    case NOTIFICATION_TYPE.INVITE: {
      const username = get(subject, 'targetUser.username');

      return {
        title: get(subject, 'targetUser.displayableName', username),
        logo: get(subject, 'targetUser.avatar.thumbMiddle'),
        id: get(subject, 'targetUser.id'),
        route: 'profile',
        translationKey:
          get(subject, 'status') === 'declined'
            ? 'community.activity.inviteDeclined'
            : 'community.activity.inviteAccepted',
        extraTitle: <span className="fw4 g-color--accent ml1">{username}</span>,
      };
    }
    case NOTIFICATION_TYPE.JOIN_REQUEST: {
      return {
        title: get(subject, 'community.name'),
        logo: get(subject, 'community.logo.thumbMiddle'),
        id: get(subject, 'community.id'),
        route: 'community',
        translationKey:
          get(subject, 'status') === 'declined'
            ? 'community.activity.requestDeclined'
            : 'community.activity.requestAccepted',
        extraTitle: null,
      };
    }
    case NOTIFICATION_TYPE.POST: {
      return {
        title: get(subject, 'community.name'),
        logo: get(subject, 'community.logo.thumbMiddle'),
        id: get(subject, 'community.id'),
        route: 'community',
        translationKey:
          get(subject, 'approvalStatus') === 'approved'
            ? 'community.activity.postApproved'
            : 'community.activity.postDeclined',
        extraTitle: null,
      };
    }
    default:
      return {};
  }
}



// WEBPACK FOOTER //
// ./src/components/Communities/Components/ActivitiesList/utils.jsx